import networkService from '../../../Network/NetworkManager';
import APPURL from '../../../Constants/URLConstants';
import {AxiosCall} from '../../../Network/AxiosCall';
import {getCartList} from '../../../Actions/getCartList';
import ToastPopup from '../../../HelperClasses/AppLoaderClasses/ToastPopup';

export const onFetchCart = async ({
  setFullCartInfo,
  setIsLoading,
  selectedUser,
  pk_key,
}) => {
  try {
    setIsLoading(true);
    const cart = await getCartList({
      setFullCartInfo,
      setIsLoading,
      selectedUser,
      pk_key,
      params: {},
    });

    setFullCartInfo(cart);
    setIsLoading(false);
  } catch (error) {
    setIsLoading(false);
    ToastPopup({
      message: error?.response?.data?.error?.message || 'Failed to add to cart',
      type: 'error',
    });
  }
};
